// extracted by mini-css-extract-plugin
module.exports = {"container":"PatientHeader_container__x4nmW","left":"PatientHeader_left__G40t-","right":"PatientHeader_right__20tAs","verticalLine":"PatientHeader_verticalLine__2KKcy"};